module.exports = __webpack_public_path__ + "media/images/crypto/ripple-7e33b7277e777c1620ffcf95bc2c758b.png";